import { Toaster } from 'react-hot-toast';

export const ToastProvider = () => {
	return <Toaster position='top-right' containerStyle={{ top: 16, right: 16 }} gutter={12} />;
};
